
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[city]/invest",
      function () {
        return require("private-next-pages/[city]/invest.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[city]/invest"])
      });
    }
  